//字符函数--29个
export const StringFunc = [
  {
    "key": "StringSubstring",
    "name": "SubString"
  },
  {
    "key": "SubString",
    "name": "SubString",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "start",
        "name": "start",
        "type": "int"
      },
      {
        "key": "length",
        "name": "length",
        "type": "int"
      }
    ],
    "description": `[Function]: Start from the specified position in the string, intercept a string of specified length and return \n[Return value type]: String (String)\n [Example]: SubString("ABCDEFG",2,3) [Return value]: "CDE"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringLength",
    "name": "Length"
  },
  {
    "key": "Length",
    "name": "Length",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      }
    ],
    "description": `[Function]: Get the length of the string \n[Return value type]: Numeric (Int32)\n [Example]: Length("ABCDEF") [Return value]: 6`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "Contains",
    "name": "Contains",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Determine whether the string contains the target string \n[Return value type]: Boolean (Boolean)\n [Example]: Contains(salesorder.code, "expression") [Return value]: false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotContains",
    "name": "NotContains",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Determine whether the string not contains the target string \n[Return value type]: Boolean (Boolean)\n [Example]: NotContains(salesorder.code, "expression") [Return value]: true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StartsWith",
    "name": "StartsWith",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Determine whether the string starts with the target string \n[Return value type]: Boolean (Boolean)\n [Example]: StartsWith(salesorder.code, "expression") [Return value]: false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotStartsWith",
    "name": "NotStartsWith",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Determine whether the string not starts with the target string \n[Return value type]: Boolean (Boolean)\n [Example]: NotStartsWith(salesorder.code, "expression") [Return value]: true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "EndsWith",
    "name": "EndsWith",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Determine whether the string ends with the target string \n[Return value type]: Boolean (Boolean)\n [Example]: EndsWith(salesorder.code, "expression") [Return value]: false`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NotEndsWith",
    "name": "NotEndsWith",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Determine whether the string not ends with the target string \n[Return value type]: Boolean (Boolean)\n [Example]: NotEndsWith(salesorder.code, "expression") [Return value]: true`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringReplace",
    "name": "Replace"
  },
  {
    "key": "Replace",
    "name": "Replace",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "oldVal",
        "name": "oldValue",
        "type": "str"
      },
      {
        "key": "newVal",
        "name": "newValue",
        "type": "str"
      }
    ],
    "description": `[Function]: Replace the "replaced value" in the string with "replacement value" \n[Return value type]: String (String)\n [Example]: Replace("123412","12"," 00") [Return value]: "003400"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringToUpper",
    "name": "ToUpper"
  },
  {
    "key": "ToUpper",
    "name": "ToUpper",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      }
    ],
    "description": `[Function]: Convert a string to upper case \n[Return value type]: String (String)\n [Example]: ToUpper("abc") [Return value]: "ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringToLower",
    "name": "ToLower"
  },
  {
    "key": "ToLower",
    "name": "ToLower",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      }
    ],
    "description": `[Function]: Convert a string to lower case \n[Return value type]: String (String)\n [Example]: ToLower("ABC") [Return value]: "abc"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringIndexOf",
    "name": "IndexOf"
  },
  {
    "key": "IndexOf",
    "name": "IndexOf",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Retrieve the target string in the string, find the first matching string and return the index position (starting from 0). If not found, it returns -1, if the target string is empty, it returns 0, if the original string is null, it returns -1 \n[Return value type]: Number (Int32)\n[Example]: IndexOf("12001234012", "01") [Return value]: 3\n [Example]: IndexOf("12002323", "34") [Return value]: -1\n[ Example]: IndexOf("120011","") [Return value]: 0`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringLastIndexOf",
    "name": "LastIndexOf"
  },
  {
    "key": "LastIndexOf",
    "name": "LastIndexOf",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      },
      {
        "key": "target",
        "name": "target",
        "type": "str"
      }
    ],
    "description": `[Function]: Retrieve the target string in the string, and return the index position (starting from 0) after finding the last matched string. If not found, it returns -1, if the target string is an empty string, it returns the length of the original string, if the original string is null, it returns -1 \n[Return value type]: Number (Int32)\n[Example]: LastIndexOf("12001234012", "01") [Return value]: 8\n [Example]: LastIndexOf("12002323", "34") [Return value]: -1\n [Example]: LastIndexOf("120011", "") [Return value]: 6`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrimStart",
    "name": "TrimStart"
  },
  {
    "key": "TrimStart",
    "name": "TrimStart",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      }
    ],
    "description": `[Function]: Delete the head space of the string and return \n[Return value type]: String (String)\n [Example]: TrimStart("ABC") [Return value]: "ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrimEnd",
    "name": "TrimEnd"
  },
  {
    "key": "TrimEnd",
    "name": "TrimEnd",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      }
    ],
    "description": `[Function]: Delete the trailing space of the string and return \n[Return value type]: String (String)\n[Example]: TrimEnd("ABC") [Return value]: "ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringTrim",
    "name": "Trim"
  },
  {
    "key": "Trim",
    "name": "Trim",
    "params": [
      {
        "key": "data",
        "name": "data",
        "type": "str"
      }
    ],
    "description": `[Function]: Delete the space at the beginning and end of the string and return \n[Return value type]: String (String)\n [Example]: Trim("ABC") [Return value]: "ABC"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CreateGuid",
    "name": "CreateGuid",
    "params": [],
    "description": `[Function]: Obtain the unique identifier Guid \n[Return value type]: String (String)\n [Example]: Unique identifier () [Return value]: "7722A793-14DF-49CD-B7E7-DF4987YYD2"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "StringAdd",
    "name": "Add"
  },
  {
    "key": "Add",
    "name": "Add",
    "params": [
      {
        "key": "str1",
        "name": "firstStr",
        "type": "str"
      },
      {
        "key": "str2",
        "name": "secondStr",
        "type": "str"
      }
    ],
    "description": `[Function]: Concatenate several strings into a new string, support up to 10 strings and at least 2; two are inserted by default in the editor, and multiple strings can be added manually. \n[Return value type]: string (String)\n[Example]: Add("Hello", "World") [Return value]: "HelloWord"`,
    "type": "String",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]